"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../../00_environment/Fonts");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _Bottom = _interopRequireDefault(require("../../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _Divider = _interopRequireDefault(require("../../01_atoms/Divider"));

var _LinkButton = _interopRequireDefault(require("../../01_atoms/LinkButton"));

var _PaymentIcon = _interopRequireDefault(require("../../01_atoms/PaymentIcon"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _serverError = _interopRequireDefault(require("../../../assets/server-error.svg"));

var _paymentError = _interopRequireDefault(require("../../../assets/payment-error.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import tire from '../../../assets/tire.svg';
var BookingErrorPageUI = function BookingErrorPageUI(_ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'server-error' : _ref$icon,
      _ref$resetSeatsAndRet = _ref.resetSeatsAndRetry,
      resetSeatsAndRetry = _ref$resetSeatsAndRet === void 0 ? false : _ref$resetSeatsAndRet,
      _ref$onResetSeatsAndR = _ref.onResetSeatsAndRetry,
      onResetSeatsAndRetry = _ref$onResetSeatsAndR === void 0 ? function () {} : _ref$onResetSeatsAndR,
      message = _ref.message,
      savedCard = _ref.savedCard,
      payWithSavedCardLink = _ref.payWithSavedCardLink,
      payWithNewCardLink = _ref.payWithNewCardLink,
      _ref$showMultiplePaym = _ref.showMultiplePaymentOptions,
      showMultiplePaymentOptions = _ref$showMultiplePaym === void 0 ? false : _ref$showMultiplePaym,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('BookingErrorPageUI');
  var payLabel = t('Retry');
  var showSavedCard = !!savedCard && showMultiplePaymentOptions;
  var pic = icon === 'payment-error' ? _paymentError["default"] : _serverError["default"];

  if (showSavedCard) {
    payLabel = /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
      id: savedCard.brand.toLowerCase(),
      style: {
        display: 'inline',
        height: '1rem',
        marginRight: 5
      }
    }), " ".concat(payLabel, " ").concat(t('with card'), " *").concat(savedCard.last4)); // payLabel = ` ${payLabel} ${t('with card')} *${savedCard.last4}`;
  }

  var cta = null;

  if (resetSeatsAndRetry) {
    cta = /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: onResetSeatsAndRetry,
      primary: true,
      fluid: true
    }, t('Retry with other seats'));
  } else if (showMultiplePaymentOptions) {
    cta = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      to: payWithNewCardLink,
      primary: true,
      fluid: true
    }, t('Try with another card')), showSavedCard && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
      text: t('or')
    }), /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
      to: payWithSavedCardLink
    }, payLabel)));
  } else {
    cta = /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: onBack,
      primary: true,
      fluid: true
    }, t('Retry'));
  }

  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Your order'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDefaultFont)({
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    })
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: pic,
    style: {
      width: 120,
      height: 'auto'
    },
    verticalAlign: "middle"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 30,
      marginBottom: 30,
      textAlign: 'center',
      maxWidth: '350px'
    }
  }, message)), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], {
    noSpacer: true
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      textAlign: 'center'
    }
  }, cta)));
};

var _default = BookingErrorPageUI;
exports["default"] = _default;